export const imgInPreprod = imageUrl => (imageUrl || '')
  .replace('toast-stage', 'toasttab') // without this, we won't see images in preprod
  .replace(/\.([^.]+)$/, '_180.$1')
